import queryString from 'query-string';

//
common.View.create('shop::website.modules.shopProducts.index.Filters', {

    setByUrl()
    {
        // Update each filter.
        for(let filterElement of this.element.find('.filter'))
            $(filterElement).data('instance').setByUrl();
    },

    getIndexInstance()
    {
        return shop.website.modules.shopProducts.Index.getInstance(this);
    },

    onUserInput()
    {
        this.getIndexInstance().onUserInput();
    },

    getFilterQuery()
    {
        let result = {};

        // Add store filter?
        if(this.element.data('store-id'))
            result['store'] = this.element.data('store-id');

        // Loop filters.
        for(let filterElement of this.element.find('.filter'))
            result = {
                ...result,
                ...$(filterElement).data('instance').getFilterQuery() || {},
            };

        // Show "remove filters"?
        $('.shop\\:\\:website-modules-shopProducts-index-filters-Remove').data('instance')
            .showRemoveFilter(result);

        //
        return result;
    },

    updateHtml(ajaxResponse)
    {
        // Get new filters.
        let newFilters = ajaxResponse.find('.shop\\:\\:website-modules-shopProducts-index-Filters .filter');

        // Delegate to each filter.
        for(let filterElement of this.element.find('.filter'))
        {
            // Get instance.
            let instance = $(filterElement).data('instance');

            // Get new filter HTML.
            let newFilterHtml = newFilters.filter('[data-filter-slug="' + instance.getFilterSlug() + '"]');

            // Delegate to filter. Use html of the first element (probarly the mobile filter) which is (now) the same as the desktop version.
            instance.setByHtml(newFilterHtml.get(0).outerHTML);
        }
    },

});
